export const APP_VERSION = 'a237ec9';
